module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso1_web.a36a42b5.png";